import { Notificacion } from '@models/.';

export function transformToData(notification: Notificacion | null): Notificacion | null {
  if (!notification) return null;
  
  return {
    ...notification,
  };
}